






























































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default defineComponent({
  name: 'UOttawaAbsenceForm',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      attachments: [] as File[],
      inputs: {
        noneRequiredModel: false,
        latePassModel: false,
        changeOfLabSectionModel: false,
        changeOfLabDayModel: false,
        medicalModel: false,
      },
    };
  },
});
